import React from "react";

export enum InfoCardType {
    SUCCESS = "success",
    INFO = "info",
    ERROR = "error",
}

interface InfoCardProps {
    title: string;
    func: () => void;
    linkText: string;
    type: InfoCardType;
}

const backgroundColors: Record<InfoCardType, string> = {
    [InfoCardType.SUCCESS]: "bg-green-500",
    [InfoCardType.INFO]: "bg-warning-500",
    [InfoCardType.ERROR]: "bg-red-500",
};

const InfoCard: React.FC<InfoCardProps> = ({ title, func, linkText, type = InfoCardType.INFO }) => {
    const backgroundColor = backgroundColors[type];

    return (
        <div className="container flex w-full px-6 pb-4 pt-6 sm:gap-3 sm:py-0 sm:pb-10 sm:pt-10">
            <div className={`flex-1 rounded-lg p-3 md:px-3 md:py-4 ${backgroundColor}`}>
                <p className="text-sm font-medium leading-[160%] tracking-[0.14px] text-white">
                    {title}&nbsp;
                    {func && (
                        <span className="cursor-pointer underline" onClick={func}>
                            {linkText}
                        </span>
                    )}
                </p>
            </div>
        </div>
    );
};

export default InfoCard;
